export const currencies = ["PLN", "EUR", "USD", "GBP"] as const;
export type Currency = typeof currencies[number];
